/**
 * Feature flag keys used throughout the application.
 * All feature flags should be defined here to maintain consistency
 * and avoid typos in flag names.
 */
export const FeatureFlags = {
  /**
   * Gates access to development/beta features (Koba)
   * for selected beta testers only. Planning is always available.
   */
  DEV_FEATURES_ACCESS: 'dev-features-access',
} as const

export type FeatureFlags = (typeof FeatureFlags)[keyof typeof FeatureFlags]

